import React, { useMemo } from "react";

//Components
import Autocomplete from "../Autocomplete";
import { statesSelect } from '../../../models/OrderEntity';

const AutocompleteOrderStates = ({ value, multiple, ...rest }) => {
    const option = useMemo(() => {
        if (!value) return multiple ? [] : '';

        if (multiple)
            return Array.isArray(value)
                ? statesSelect.filter(b => value.some(v => b.value === v))
                : [statesSelect.find(b => b.value === value)];

        return statesSelect.find(b => b.value === value)
    }, [multiple, value])

    return (
        <Autocomplete
            fullWidth
            size='small'
            name='state'
            loadingText='Buscando estados...'
            label='Estado'
            {...rest}
            multiple={multiple}
            value={option}
            options={statesSelect}
            isOptionEqualToValue={(option, value) => option.value === value}
            data-testid="order-states-autocomplete"
        />
    );
}

export default AutocompleteOrderStates;